// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"178":"2714d291","310":"4be8bda6","548":"4ca76614","686":"25aa448e","726":"1098f24e"}[chunkId] + ".chunk.js";
};